import groups from './groups/index'
import users from './users/index'
import { getAxiosInstance, getDomain } from '@modv/sdk'
import { Message } from 'element-ui'

export default {
  namespaced: true,
  state: {
    ...groups.state,
    ...users.state,
    brand: {}
  },
  getters: {
    ...groups.getters,
    ...users.getters
  },
  mutations: {
    ...groups.mutations,
    ...users.mutations,
    CLEAR_SELECT_ENTITIES: (state) => {
      if (state.groups) {
        state.groups.forEach((element) => {
          element.isSelect = false
        })
      }
      if (state.adminUsers) {
        state.adminUsers.forEach((element) => {
          element.isSelect = false
        })
      }
      if (state.users) {
        state.users.forEach((element) => {
          element.isSelect = false
        })
      }
    },
    UPDATE_BRAND(state, params) {
      state.brand = params
    }
  },
  actions: {
    ...groups.actions,
    ...users.actions,

    async clearContents({ commit, dispatch }, params) {
      commit('CLEAR_CONTENT', params)
    },
    async getBrand({ commit }, params) {
      const { data } = await getAxiosInstance().get(`${getDomain()}/admin/brand/${params.brandId}`)
      commit('UPDATE_BRAND', data)
    },
    async getSecret({ commit }, { organisationId }) {
      const { data } = await getAxiosInstance().get(`${getDomain()}/admin/organisation/${organisationId}/secret`)
      return data
    },
    async removeSecret({ commit }, { organisationId, index }) {
      await getAxiosInstance().delete(`${getDomain()}/admin/organisation/${organisationId}/secret`, { params: { index }})
      Message.success('deleted')
    }
  }
}
